import type { ReactElement } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './GroupExpandToggle.module.css';

export interface GroupExpandToggleProps {
  expanded: boolean;
  /** e.g. "12 people" — reused as the visible label, not just an icon (F33 "+N more" affordance). */
  countLabel: string;
  expandLabel: string;
  collapseLabel: string;
  onToggle: () => void;
}

/** Collapsed/expanded toggle for a grouped notification row's detail body (F33). */
export function GroupExpandToggle({ expanded, countLabel, expandLabel, collapseLabel, onToggle }: GroupExpandToggleProps): ReactElement {
  return (
    <button
      type="button"
      className={styles['toggle']}
      aria-expanded={expanded}
      onClick={(event) => {
        // Stop the click from bubbling into the parent item's own
        // "open/mark-read" `<button>` — nested interactive elements can't
        // be avoided here (F33's per-item row is itself a click target),
        // so this toggle explicitly owns just its own click.
        event.stopPropagation();
        onToggle();
      }}
    >
      <ChevronDown size={14} aria-hidden="true" className={expanded ? styles['chevronOpen'] : undefined} />
      <span>{expanded ? collapseLabel : `${countLabel} · ${expandLabel}`}</span>
    </button>
  );
}
